<template>
  <div class="product">
    <ProductCard v-if="teaser" :rate="rate" title="Professional indemnity" />
    <ProductConfig v-else class="product-config" :rate="rate">
      <div class="container-wrap">
        <p class="text-base font-bold block ">
          Select your limit for professional indemnity
        </p>
        <AppSelect v-model="form.limit" placeholder="Select amount" @input="handleInput">
          <option v-for="value in limits" :key="value" :value="value">
            {{ value | currency }}
          </option>
        </AppSelect>
      </div>

      <div v-if="$store.getters.getIndustryId.includes('b4398052-fd73-4778-bed6-a6b015179d8a')" class="container-wrap">
        <p class="text-base font-bold block">
          Do you carry valuations?
        </p>
        <AppSelect v-model="form.valuations" placeholder="Select amount" @input="handleInput">
          <option value="0">None</option>
          <option value="50000">Up to £50,000</option>
          <option value="50001">Over £50,000</option>
        </AppSelect>
      </div>

      <div v-if="$store.getters.getIndustryId.includes('c219e91e-ad81-4ea5-bf42-5ec8b2f3703a')" class="container-wrap">
        <AppSwitch v-model="form.securityServices" :true-value="1" :false-value="0" @input="handleInput">
          <div slot="label">Do you provide any commercial or industrial security services?</div>
        </AppSwitch>
      </div>

      <div v-if="subindustries.length > 0" class="container-wrap">
        <p class="text-base font-bold block">
          Which professional services do you provide? (Select all that apply)
        </p>
        <DrInputCheckbox
          v-for="subindustry in subindustries"
          :key="subindustry.id"
          v-model="form.subindustry"
          :value="subindustry.id"
          class="mb-4"
          @change="handleInput"
        >
          <span class="-mt-1 text-2xs text-grey-500 leading-snug">
            {{ subindustry.title }}
          </span>
        </DrInputCheckbox>
      </div>

      <div v-if="$store.getters.getHasNorthAmericanCustomers" class="container-wrap">
        <p class="text-base font-bold block">
          Do you want to include cover for claims brought against you in courts in the USA and Canada?
        </p>
        <AppSelect v-model="form.worldwideJurisdiction" placeholder="Select amount" @input="handleInput">
          <option value="0">No</option>
          <option value="1">Yes</option>
        </AppSelect>
      </div>
    </ProductConfig>
  </div>
</template>

<script>
import ProductCard from '@/components/products/Card.vue'
import ProductConfig from '@/components/products/Config.vue'
import AppSelect from '@/components/products/form/Select.vue'
import AppSwitch from '@/components/products/form/Switch.vue'
import rateMixin from '@/mixins/rate'

export default {
  filters: {
    numberWithCommas: (val, zeroValue) => {
      return val > 0 ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : zeroValue
    },
  },
  components: {
    ProductCard,
    ProductConfig,
    AppSelect,
    AppSwitch,
  },
  mixins: [rateMixin],
  props: {
    teaser: {
      type: Boolean,
      default: false,
    },
    rate: {
      type: Object,
      required: true,
    },
  },
  data () {
    if (this.teaser) return {}

    const defaultRatingInputs = {
      id: 'ProfessionalInsurance',
      key: 'ProfessionalInsurance\\ProfessionalIndemnity',
      active: true,
      description: 'Professional Indemnity',
      limit: null,
      subindustry: [],
      worldwideJurisdiction: 0,
    }

    // overwrite defaults with what ratingEngine returns
    let ratingInputs = { ...defaultRatingInputs, ...this.rate.ratingInputs }

    // if there's a rate passed, overwrite default inputs
    const rate = this.getRate(this.rate.key)
    if (rate) ratingInputs = { ...ratingInputs, ...rate.ratingInputs }

    let limits = [50000, 100000, 250000, 500000, 750000, 1000000, 2000000]

    // provide limit of 5m for technology, media, management consultants or recruitment consultants
    if (
      [
        'bc3e7edc-0e80-4305-921a-061741748d76',
        'a16f1768-e9a6-4784-9156-3618ebed9849',
        '6b25abb3-d813-4ee6-a12c-7ec4bba3bdc0',
        '7475b9a6-3fe7-4ded-a726-729a7f9ffa80',
      ].filter(x => this.$store.getters.getIndustryId.includes(x)).length > 0
    ) { limits = [50000, 100000, 250000, 500000, 750000, 1000000, 2000000, 3000000, 4000000, 5000000] }

    const availableRate = this.getAvailableRate(this.rate.key)
    const subindustries = availableRate.config.options.subindustries || []

    return {
      productKey: 'ProfessionalInsurance',
      loading: false,
      limits,
      subindustries,
      form: {
        ...ratingInputs,
        // can't access this.getters here - need to access directly via $store
        productUuid: this.getAvailableProduct('ProfessionalInsurance').id,
        industryId: this.$store.getters.getIndustryId,
        turnover: this.$store.getters.getTurnover,
        employeeCount: this.$store.getters.getEmployeeCount,
      },
    }
  },
  mounted () {
    if (!this.teaser) {
      this.handleSubmit()
    }
  },
  methods: {
    validate () {
      if (!this.form.limit || (this.subindustries.length > 0 && this.form.subindustry.length === 0)) return false

      return true
    },
    handleSubmit () {
      // reset estimate if it has already been submitted for this rate
      this.$store.commit('updateEstimate', null)

      if (!this.validate()) {
        return
      }

      this.loading = true

      this.updateRate(this.form)
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false))
    },
    handleInput () {
      this.handleSubmit()
    },
  },
}
</script>
